import React from 'react';
import classNames from 'classnames';
import { useButtonStyles } from './button.styles';
import LoadingSpinner from '../LoadingSpinner';
function Button({ children, dataTestid, disabled = false, theme = 'primary', size = 'medium', className, variant = 'default', onClick, wide = false, type = 'button', loading = false, bold = false, margin = true, }) {
    const classes = useButtonStyles({ margin });
    const composedClassName = classNames(className, classes.button, classes[theme], classes[size], classes[variant], {
        [classes.buttonLoading]: loading,
        [classes.disabled]: disabled,
        [classes.wide]: wide,
        [classes.bold]: bold,
    });
    return (React.createElement("button", { className: composedClassName, disabled: disabled, onClick: onClick, type: type, "data-testid": dataTestid },
        React.createElement("div", { className: classes.contents }, loading ? React.createElement(LoadingSpinner, { color: "#FFFFFF", size: "small" }) : children)));
}
export default Button;
//# sourceMappingURL=Button.js.map